import styled from 'styled-components';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import MonitorContext from '../../MonitorContext';
const Container = styled.div`
  display: inline-block;
  margin-left: 2px;
  margin-right: 5px;
`;

export interface IUnitContainerProps {
  field: string;
  style?: any;
}

export default function UnitContainer(props: IUnitContainerProps) {
  const s80 = useSelector((state: any) => state.executor.s80);
  const { monitorFields } = s80;
  const context = useContext<any>(MonitorContext);

  const { field, ...rest } = props;
  if (!monitorFields[`${context.monitor}_${field}`]) {
    return <Container {...rest}></Container>;
  }
  const { unit } = monitorFields[`${context.monitor}_${field}`];
  return <Container {...rest}>{unit}</Container>;
}
